<template>
  <div class="inputs">
    <div class="input">
      <label>Address 1 <span class="required">*</span></label>
      <input
        @keypress="addAutocomplete('address')"
        ref="address_address_1"
        type="text"
        v-model="$parent.client.address.address_1"
      />
    </div>
    <div class="input">
      <label>Address 2</label>
      <input ref="address_address_2" type="text" v-model="$parent.client.address.address_2" />
    </div>
    <div class="input">
      <label>Address 3</label>
      <input ref="address_address_3" type="text" v-model="$parent.client.address.address_3" />
    </div>
    <div class="input">
      <label>Zip Code <span class="required">*</span></label>
      <input ref="address_zip" type="text" v-model="$parent.client.address.zip" />
    </div>
    <div class="input">
      <label>City <span class="required">*</span></label>
      <input ref="address_city" type="text" v-model="$parent.client.address.city" />
    </div>
    <div class="input">
      <label>State <span class="required">*</span></label>
      <v-select
        label="name"
        :options="states"
        :reduce="state => state.name"
        ref="address_state"
        v-model="$parent.client.address.state"
      />
    </div>

    <div class="input">
      <label>Country <span class="required">*</span></label>
      <v-select
        :options="countries"
        label="name"
        ref="address_country"
        v-model="$parent.client.address.country"
      />
    </div>
  </div>
</template>

<script type="text/javascript">
import csc from "country-state-city";
export default {
  props: ["inputAddress"],
  data() {
    return {
      countries: this.getCountries(),
      states: [],
      address: {
        name: "",
        email: "",
        phone: "",
        address_1: "",
        address_2: "",
        address_3: "",
        city: "",
        state: "",
        country: "United States",
        zip: "",
        created_at: Date.now(),
      },
      initialLoad: false
    };
  },

  watch: {
    inputAddress() {
      if (this.inputAddress) {
        if (this.initialLoad) {
          this.$parent.client.address = this.inputAddress;
        }else {
          this.initialLoad = true;
        }
      }
    },
    address: {
      deep: true,
      handler() {
        let country_id = "231";
        if (typeof this.$parent.client.address.country == "object")
          country_id = this.$parent.client.address.country.id;

        this.states = csc.getStatesOfCountry(country_id);
      },
    },
  },

  methods: {
    getCountries(){
      let countries = []
      countries.push(csc.getCountryByCode('US'));
      countries.push(csc.getCountryByCode('CA'));
      return countries
    },
    handleAddressSelect(item) {
      if (item) {
        this.$parent.client.address.address_1 = item.address_1;
        this.$parent.client.address.address_2 = item.address_2;
        this.$parent.client.address.country = item.country;
        this.$parent.client.address.city = item.city;
        this.$parent.client.address.state = item.state;
        this.$parent.client.address.zip = item.zip;
        this.addressState = this.states.us.filter(
          (state) => state.code === item.state
        )[0];
        this.address_active = true;
      }
    },
    // createMapImg() {
    //   let address = `${this.address.address_1},${this.address.city},${this.address.state},${this.address.country}`;
    //   let url = `https://maps.googleapis.com/maps/api/staticmap?markers=${address}&zoom=18&size=600x300&maptype=roadmap&key=AIzaSyBhQ-HqqQCnlQewEiWuR2bcI18yJWvP174`;
    //   return url;
    // },
    addAutocomplete(name) {
      this.autocomplete = new google.maps.places.Autocomplete(
        this.$refs[name + "_address_1"],
        { types: ["geocode"] }
      );
      let vm = this;
      this.autocomplete.addListener("place_changed", () => {
        vm.$parent.client[name].address_2 = "";
        let place = this.autocomplete.getPlace();
        let ac = place.address_components;
        let add1 = "";
        ac.forEach((c) => {
          if (c.types.includes("street_number")) {
            add1 = `${c.short_name} `;
          } else if (c.types.includes("route")) {
            add1 += `${c.short_name}`;
          } else if (
            c.types.includes("locality") ||
            c.types.includes("sublocality_level_1")
          ) {
            vm.$parent.client[name].city = c.long_name;
          } else if (c.types.includes("administrative_area_level_1")) {
            vm[name + "State"] = c.long_name;
            vm.$parent.client[name].state = c.long_name;
          } else if (c.types.includes("country")) {
            vm.$parent.client[name].country = c.long_name;
          } else if (c.types.includes("postal_code")) {
            vm.$parent.client[name].zip = c.short_name;
          }
          vm.$parent.client[name].address_1 = add1;
          //   vm.$parent.client[name].map = this.createMapImg();
        });
        let lat = place.geometry.location.lat();
        let lon = place.geometry.location.lng();
        let city = ac[0]["short_name"];
        // this.$emit("autoCompleteAddress", vm.address);
      });
    },
  },
};
</script>
